
      function loadScript(src, callback) {
        var script = document.createElement('script');
        script.src = src;
        script.onload = callback;
        document.body.appendChild(script);
      }
      let url = '/vendor/jquery-1.11.0.min.js';
      // let url = 'https://ajax.googleapis.com/ajax/libs/jquery/1.11.0/jquery.min.js';
      // if (import.meta.env.VITE_REGION === 'china') {
      //   url = 'https://app.assessprep.cn/cdn/1.11.0/jquery.min.js';
      // }

      loadScript(url, function () {
        console.log('jQuery loaded');

        loadScript('/mathquill-0.10.1/mathquill-matrix.min.js', function () {
          console.log('MathQuill loaded');
          try {
            window.MQ = MathQuill.getInterface(2);
          } catch (error) {
            window.MQ = {};
            console.log('MathQuill load fail', error);
          }
        });
      });
    